// extracted by mini-css-extract-plugin
module.exports = {"container":"InputNumEditions_Compact_container__Aj_Ic"};